import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema, additionalState, edit_fields } from './config';

import { useParams } from 'react-router-dom';


const EditInventory = ({dialog = false, ignore_id = false}) => {
  const { id } = useParams();

  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);
  const [initValues, setInitValues] = useState(initialValues);

  useEffect(() => {
    if (id && !ignore_id) {
      setFormFields([...edit_fields.map(field => ({...field}))]);
    }
  }, [id, ignore_id]);

  return (
    <EditForm title={"Inventory"} initialValues={initValues} fields={formFields} schema={schema} url={"inventory"} 
      additionalState={additionalState} dialog={dialog} ignore_id={ignore_id}>
      
     </EditForm>
  );
}

export default EditInventory;